import { useParams } from 'react-router-dom'

import { Box, Button, DataGrid, FavouriteCharityButton, Icons, Link, Stack, Text } from '../../components'

export function GenerosityFundSearchResults({ loading, count = 0, page, onPageChange, funds = [] }) {
  const { fundId: myFundId } = useParams()
  const columns = [
    {
      field: 'fund',
      headerName: 'Fund',
      minWidth: 300,
      flex: 2,
      renderCell: ({ id, row: { name } = {} }) => (
        <Stack spacing={0}>
          <Text.Body>
            <Link to={`/funds/${myFundId}/share-funds-with-generosity-fund/${id}`}>
              <strong>{name}</strong>
            </Link>
          </Text.Body>
        </Stack>
      ),
      valueGetter: ({ id, row: { accountName } = {} }) => `${accountName} ${id}`,
    },
    {
      field: 'grant',
      flex: 1,
      minWidth: 200,
      sortable: false,
      filterable: false,
      renderHeader: () => (
        <Stack spacing={0}>
          <Box>View Details & Give</Box>
        </Stack>
      ),
      renderCell: ({ id }) => (
        <Button
          sx={{ background: 'transparent', pl: 1, pr: 0, textTransform: 'none' }}
          to={`/funds/${myFundId}/share-funds-with-generosity-fund/${id}`}
        >
          View & Give
          <Icons.KeyboardArrowRight />
        </Button>
      ),
    },
  ]

  return (
    <DataGrid
      disableExport
      autoRowHeight
      title="Generosity Funds"
      rows={funds}
      columns={columns}
      paginationMode="server"
      rowCount={count}
      page={page}
      pageSize={9}
      onPageChange={onPageChange}
      loading={loading}
      sx={{
        '& .MuiDataGrid-virtualScroller': {
          marginTop: '5rem !important',
        },
        '& .MuiDataGrid-columnHeaders': {
          maxHeight: '5rem !important',
          height: '5rem !important',
          lineHeight: '1.5rem !important',
        },
      }}
    />
  )
}
